import SurveyResponse from './SurveyResponse.vue'

export default SurveyResponse